import { useRouteMatch } from 'react-router-dom';
import { useMemo } from 'react';

export const useType = (createUrl) => {
  const createRoute = useRouteMatch(createUrl);

  return useMemo(() => (createRoute ? 'create' : 'edit'), [createRoute]);
};
